import { SET_PRICING_MODULE } from '../actions/types';

const initialState = {
	useModule: false
};

export default function pricingModuleData(state = initialState, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_PRICING_MODULE:
				return { ...state, ...action.payload };
			default:
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/pricingModule.js